import { createSelector } from "reselect";
import * as Models from "../models/index";

const getPassword = (state: Models.StoreState) => state.pwdSecurity.password;
const getConfirmPassword = (state: Models.StoreState) => state.pwdSecurity.confirmPassword;
const getUserPwdValidationResult = (state: Models.StoreState) => state.pwdValidate.userPwdValidationResult;

export const isNeededValidation = createSelector(getPassword, getConfirmPassword, getUserPwdValidationResult, (getPassword, getConfirmPassword, getUserPwdValidationResult) => {
    return (getPassword !== getConfirmPassword || getPassword === "" || getUserPwdValidationResult.filter(x => !x.isPassed).length !== 0);
});